/**
 * Created For: 地图相关接口
 * Author: chenLiYan.
 * Date: 2018/11/30 0030 15:43.
 */
import request from '@/utils/request'
export function salesFlowList(data) {
  return getData('stdSalesFlow', data)
}

export function getData(code, data) {
  return request({
    url: '/api/data/' + code + '/query',
    method: 'post',
    data
  })
}

export function queryMeta(code) {
  return request({
    url: '/api/meta/' + code + '/query',
    method: 'get'
  })
}

export function salesFlowMeta() {
  return queryMeta('stdSalesFlow')
}

export function purchaseFlowMeta() {
  return queryMeta('stdPurchaseFlow')
}

export function inventoryFlowMeta() {
  return queryMeta('stdInventoryFlow')
}

export function appealList({
  id,
  appealType,
  appealStatus,
  flowType,
  suppliersCodes,
  clientCodes,
  skuCode,
  resultType,
  creatorName,
  handlerName,
  page,
  pageSize
}) {
  return request({
    url: '/appeal/v1/query',
    method: 'post',
    data: {
      id,
      appealType,
      appealStatus,
      flowType,
      suppliersCodes,
      clientCodes,
      skuCode,
      resultType,
      creatorName,
      handlerName,
      page,
      pageSize
    }
  })
}

export function appealDetail(id) {
  return request({
    url: '/appeal/v1/detail/' + id,
    method: 'get'
  })
}

export function getdictOptionByForm(params) {
  return request({
    url: '/api/dict-option-by-form',
    method: 'get',
    params
  })
}

export function getProductTreeList(keyword) {
  return request({
    url: '/mdm/api/data/product/tree',
    method: 'get',
    params: {
      keyword
    }
  })
}

export function saveAndSubmitAppeal(data) {
  return request({
    url: '/appeal/v1/save-and-submit',
    method: 'post',
    data
  })
}

export function editAndSubmitAppeal(id, data) {
  return request({
    url: '/appeal/v1/edit-and-submit/' + id,
    method: 'post',
    data
  })
}

export function saveAppeal(data) {
  return request({
    url: '/appeal/v1/save',
    method: 'post',
    data
  })
}

export function editAppeal(id, data) {
  return request({
    url: '/appeal/v1/edit/' + id,
    method: 'post',
    data
  })
}

export function deleteAppeal(id) {
  return request({
    url: '/appeal/v1/remove/' + id,
    method: 'delete'
  })
}

export function getByLevelList(keyword, level = 3) {
  return request({
    url: '/mdm/api/data/dept/by-level',
    method: 'get',
    params: {
      keyword,
      level
    }
  })
}

export function getProvinceList(keyword) {
  return request({
    url: '/mdm/api/data/area/province-keyword',
    method: 'get',
    params: {
      keyword
    }
  })
}

// 纯销达成表现
export function buyerPureSalesReach(data) {
  return request({
    url: '/buyer-pure-sales/reach',
    method: 'post',
    data
  })
}

// 近6个月的纯销趋势
export function buyerPureSalesMonthList(data) {
  return request({
    url: '/buyer-pure-sales/month-list',
    method: 'post',
    data
  })
}

// 终端纯销明细
export function buyerPureSalesList(data) {
  return request({
    url: '/buyer-pure-sales/list',
    method: 'post',
    data
  })
}
